var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hideAccountPausedNotification && _vm.isAdmin
      ? _c(
          "div",
          {
            staticClass:
              "top-alert-box top-alert-box-danger top-alert-box--center top-alert-box--small slide-down slide-down--medium-duration"
          },
          [
            _c("i18n", {
              attrs: { path: "ACCOUNT_BILLING_PAUSED", tag: "span" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "link",
                    fn: function() {
                      return [
                        _c(
                          "a",
                          { attrs: { href: "/#/dashboard/billing-settings" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("ACCOUNT_BILLING_PAUSED_LINK"))
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1620742314
              )
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.onCloseAccountPausedNotification()
                  }
                }
              },
              [
                _c("i", {
                  staticClass:
                    "fa fa-times-circle top-alert-box__centered_close"
                })
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.hideUploadKycNotification && _vm.isAdmin
      ? _c(
          "div",
          {
            staticClass:
              "top-alert-box top-alert-box-danger top-alert-box--center top-alert-box--small slide-down slide-down--medium-duration",
            class: _vm.hideAccountPausedNotification ? "" : "m-t-47"
          },
          [
            _c("i18n", {
              attrs: { path: "UPLOAD_KYC_NOTIFICATION_MESSAGE", tag: "span" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "link",
                    fn: function() {
                      return [
                        _c(
                          "a",
                          { attrs: { href: "/#/dashboard/billing-settings" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("UPLOAD_KYC_NOTIFICATION_MESSAGE_LINK")
                              )
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                409023101
              )
            }),
            _vm._v(" "),
            _c("span", { on: { click: _vm.onCloseKycNotification } }, [
              _c("i", {
                staticClass: "fa fa-times-circle top-alert-box__centered_close"
              })
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }